import initCookies from './components/cookies';
import initSplash from './components/home/splash';
import initHomeGallery from './components/home/gallery';
import initThinking from './components/home/thinking';

// Initialise Cookies first so show() works in splash
initCookies();

const splashEl = document.querySelector('.js-splash');

if (splashEl) {
    initSplash(splashEl);
}

const homeGallery = document.querySelector('.js-home-gallery');

if (homeGallery) {
    initHomeGallery(homeGallery);
}

const thinkingSection = document.querySelector('.js-thinking');

if (thinkingSection) {
    initThinking(thinkingSection);
}
